// Stock: none, a rounded stub, or a full tapered stock with a butt plate.
import { detailStroke, type Part, part } from '../../passes.ts';
import { box, line, roundPoly } from '../../shapes.ts';
import { type GunKit, lrect } from './types.ts';

export function stock(g: GunKit): Part[] {
  const { kind, len, h } = g.r.stock;
  if (kind === 'none') return [];
  const rx = g.r.receiver.x;
  const ry = g.r.receiver.y;
  if (kind === 'stub') return [lrect(g, g.r.main, rx - len, ry + 2, len + 6, h, h * 0.45)];
  const x0 = rx - len;
  const pts: [number, number][] = [
    [rx + 4, ry + 1],
    [rx + 4, ry + g.r.receiver.h - 2],
    [x0, ry + h + 2],
    [x0, ry - 3],
  ];
  const sw = g.pal.sw(g.r.accent);
  return [
    part(roundPoly(pts, 4), sw, box(x0, ry - 3, len + 4, h + 5), {
      detail: (c) =>
        detailStroke(
          c,
          line([
            [x0 + 4, ry],
            [x0 + 4, ry + h - 1],
          ]),
          sw.outline,
          g.ow * 0.7,
        ),
    }),
  ];
}
